import { render, staticRenderFns } from "./buy-transaction-amount-picker.vue?vue&type=template&id=5ceb22ee&"
import script from "./buy-transaction-amount-picker.vue?vue&type=script&lang=js&"
export * from "./buy-transaction-amount-picker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports